(() => {
  for (const banner of document.querySelectorAll('[data-rv-promo]')) {
    if (banner.dataset.rvPromoReady === 'true') continue;
    const button = banner.querySelector('[data-rv-promo-copy]');
    const code = banner.querySelector('[data-rv-promo-code]');
    const status = banner.querySelector('[data-rv-promo-status]');
    if (!(button instanceof HTMLButtonElement) || !(code instanceof HTMLInputElement) || !status) continue;
    banner.dataset.rvPromoReady = 'true';
    button.disabled = false;
    button.addEventListener('click', async () => {
      button.disabled = true;
      status.textContent = '';
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(code.value);
        button.textContent = button.dataset.copiedLabel;
        status.textContent = button.dataset.successMessage;
      } catch {
        code.focus();
        code.select();
        button.textContent = button.dataset.manualLabel;
        status.textContent = button.dataset.failureMessage;
      } finally {
        button.disabled = false;
      }
    });
  }
})();
